// extracted by mini-css-extract-plugin
export default {"p":"_92509b3cc1 _3a0af71935 _8079a3831d","clr":"d77fdd6b79","dls":"_415486f104"};